import React, { FC } from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { KatIcon } from "@amzn/katal-react";

export interface ExpandableArrowProps {
  isExpanded: boolean;
  onToggle: () => void;
  isFetching?: boolean;
}

const ExpandableArrow: FC<ExpandableArrowProps> = ({
  isExpanded,
  onToggle,
  isFetching = false,
}) => {
  const isDisabled = isFetching;
  return (
    <KatIcon
      name={isExpanded ? "expand_less" : "expand_more"}
      size={"small"}
      onClick={isDisabled ? undefined : onToggle}
      className={classNames(styles.expandable_arrow, {
        [styles.disabled]: isDisabled,
      })}
    />
  );
};

export default ExpandableArrow;
